import { createCurrencyTV } from "../../../models/currency.model";
import { tv } from "../../../models/text-value.model";
import { createCountriesTV } from "../../../models/country.model";
import { createUserTV } from "../../../models/user.model";
import { createLanguageTV } from "../../../models/language.model";

export const makeSelectedInvoice = (state) => {
  const selectedInvoice = state.selectedInvoice || {};

  // if (!selectedInvoice) {
  //   return {};
  // }

  const invoice = selectedInvoice.invoice || {};
  const lock_flag = invoice.lock_flag || false;
  const disabled = lock_flag == 1 ? true : false;


  const currencies = selectedInvoice.currencies || [];
  const invoiceCurrencyId = invoice.currency_id || '';

  const invoiceCurrency = currencies.find(e => e.currency_id == invoiceCurrencyId) || {
    currency_id: '2',
    currency_iso: 'EUR',
  };

  const invoice_projects = selectedInvoice.invoice_projects || [];
  const invoice_projectsTV = invoice_projects.map(tv(
    'invoice_project_name',
    'invoice_project_id'
  ));

  const currenciesTV = createCurrencyTV(currencies);

  const users = selectedInvoice.users || [];
  const usersTV = createUserTV(users);

  const languages = selectedInvoice.languages || [];
  const languagesTV = createLanguageTV(languages);

  const contact = selectedInvoice.contact || {};

  const payment_methods = selectedInvoice.payment_methods || [];
  const payment_methodsTV = payment_methods.map(tv(
    'payment_method_name',
    'payment_method_id'
  ));

  const money_accounts = selectedInvoice.money_accounts || [];
  const money_accountsTV = money_accounts.map(tv(
    'money_account_name',
    'money_account_id'
  ));

  const tax_deductions = selectedInvoice.tax_deductions || [];
  const tax_deductionsTV = tax_deductions.map(tv(
    'tax_name',
    'tax_type_id'
  ));
  const selectedTaxDeduction = (tax_deductionsTV.find(c => c.value == invoice.tax_type_id_deduction) || {}).text;

  const invoicelines = selectedInvoice.invoicelines || [];

  const artist_payments = selectedInvoice.artist_payments || [];
  const agent_payments = selectedInvoice.agent_payments || [];


  return {
    ...selectedInvoice,
    invoice,
    contact,
    lock_flag,
    disabled,
    invoiceCurrency,
    invoice_projects,
    invoice_projectsTV,
    currencies,
    currenciesTV,
    users,
    usersTV,
    languages,
    languagesTV,
    payment_methods,
    payment_methodsTV,
    money_accounts,
    money_accountsTV,
    tax_deductions,
    tax_deductionsTV,
    selectedTaxDeduction,
    invoicelines,
    artist_payments,
    agent_payments,
  }
}